import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The prince hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a deep royal-blue + gold storybook palette, the
 * boy counterpart to royal's rose + gold. Choosing him recolours the WHOLE kid shell: the brand ramp drives
 * buttons / meters / rings in blue, the canvas blooms cool-to-warm to a blue+gold dawn, and the hero stage
 * takes his twilight-castle sky. Every brand colour is paired with its own foreground for legibility.
 */
export const princeTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — royal blue. `soft`→`primary` is the button/meter gradient (white text); `deep` is on-light
  // text (≈ 8:1 on the light kid surfaces); `tint` is the softest fill; `glow-rgb` = #3B5FA3 for coloured shadows.
  '--color-primary': '#3B5FA3',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#6C8FCB',
  '--color-primary-deep': '#2A4A85',
  '--color-primary-tint': '#E4EBF9',
  '--color-primary-glow-rgb': '59 95 163',
  '--color-secondary': '#DCE6F6',
  '--color-secondary-fg': '#1F3A5F',
  '--color-accent': '#F2C14E',
  '--color-accent-fg': '#4A3A00',
  // CANVAS — a soft blue bloom top-left, a warm-gold bloom bottom-right (the same shared storybook dawn as royal).
  '--canvas-a': '#E2EAF9',
  '--canvas-b': '#FCEFD8',
  // A deep twilight-castle-blue sky (white text stays AA over it).
  '--sky-top': '#16213e',
  '--sky-mid': '#2c4a7c',
  '--sky-low': '#8fb0d9',
  '--sky-glow': '#ffd9a0',
  '--sky-fg': '#ffffff',
});
